import { Certificate } from '@legacy-types';

import { api } from '@shared/api/api';
import { Nullable } from '@shared/utils/types/Nullable';

export type CreateCertificateData = Nullable<
  Pick<Certificate, 'description' | 'type' | 'expiresAt'> & { files: File[], companyId: number }
>;

export function createCertificateForUserAndCompany(
  userId: number,
  companyId: number,
  data: CreateCertificateData
): Promise<Certificate> {
  const formData = new FormData();

  formData.append('description', data.description ?? '');
  formData.append('type', data.type ?? '');
  formData.append('expiresAt', data.expiresAt ?? '');
  (data.files ?? []).forEach((file: File) => {
    formData.append('files[]', file);
  });

  return api.postFormData(`companies/${companyId}/users/${userId}/certificates`, formData);
}
